import Cookies from 'js-cookie';

export function andyouArchive() {
  const triggerGrid = document.querySelector('.js-trigger-andyou-view-grid');
  const triggerList = document.querySelector('.js-trigger-andyou-view-list');

  if(triggerGrid && triggerList) {
    triggerGrid.addEventListener('click', function(e) {
      triggerGrid.classList.add('is-current');
      triggerList.classList.remove('is-current');
      document.getElementById("html-root").classList.add('is-andyou-archive-grid');
      document.getElementById("html-root").classList.remove('is-andyou-archive-list');
      Cookies.set('meandyou-andyou-archive-grid', '1');
      e.preventDefault();
    });
    triggerList.addEventListener('click', function(e) {
      triggerList.classList.add('is-current');
      triggerGrid.classList.remove('is-current');
      document.getElementById("html-root").classList.add('is-andyou-archive-list');
      document.getElementById("html-root").classList.remove('is-andyou-archive-grid');
      Cookies.set('meandyou-andyou-archive-grid', '0');
      e.preventDefault();
    });
  }
}